<template>
  <head>
    <link rel='canonical' :href="`${link}`"/>
  </head>
  <div 
    class="app-ctn"
    ref="app"
    :style="`overflow-y: ${type === 'desktop'? 'scroll': 'hidden'};`">
    <router-view/>
    <div v-if="type === 'desktop' && route.name !== 'ageguard'" class="footer-app-ctn">
      <hr size="2" width="90%" color="grey">
      <div class="cta-list">
        <div @click="router.push({path: '/en/legal/TermsAndCondition'})">{{t("Legal-Terms")}}</div>
        <div onclick="Optanon.ToggleInfoDisplay()">{{t("Cookie-Policies")}}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { Capacitor } from '@capacitor/core';
const store = useStore()
const link = window.location.href
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const app = ref()

let winHeight = ref(window.innerHeight)
let type = ref('desktop')

const resize = () => { winHeight.value = window.innerHeight } 

if (Capacitor.getPlatform() === 'web' && !Capacitor.isNativePlatform()) type.value = 'desktop';
else type.value = "mobile";
if (window.matchMedia('(display-mode: standalone)').matches) type.value = "mobile"

window.addEventListener('contextmenu', function (e: MouseEvent) { e.preventDefault(); return false; }, false);

if (!window.matchMedia('(display-mode: standalone)').matches)
  window.addEventListener("beforeunload", () => {
    store.dispatch('setAgeValid', false) 
  })

onMounted(() => {
  console.log('commit:', process.env.VUE_APP_COMMIT)
  app.value.onresize = resize
})

onUnmounted(() => { 
  store.dispatch('setAgeValid', false)
})
</script>


<script lang="ts">
import { defineComponent, onUnmounted, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterView, useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'HomeView',
});
</script>

<style lang="scss">
@import "@/styles/app.scss";

.app-ctn {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.app-ctn::-webkit-scrollbar { 
  display: none;
}
.footer-app-ctn {
  padding-top: 1vh;
  padding-bottom: 1vh;
  width: 100%;
  background-color: #222222;
  color: grey;
  font-weight: 600;
  
  hr {
    margin-bottom: 1vh;
  }

  .cta-list {
    margin: auto;
    width: 90%;
    display: flex;
    justify-content: space-between;

    div {cursor: pointer}
  }
}

#app {
  background-color: rgb(250, 250, 250);
  color: black;
  font-family: MoetHennessy, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 0px !important;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  text-align: center;
  color: #2c3e50;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
</style>